module.exports = __webpack_public_path__ + "static/media/getthebox@2x.ec8f161e.png";